import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=1159a704&scoped=true&"
import script from "./RoleCreate.vue?vue&type=script&lang=js&"
export * from "./RoleCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=1159a704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159a704",
  null
  
)

export default component.exports